export const REDUCER_KEY = 'favourites';
export const SET_FAVOURITE_PERSONS = 'SET_FAVOURITE_PERSONS';


